import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import splashImg from '../../css/images/splash-register.jpg'

export default function SplashRegister() {
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      localStorage.setItem('splashRegisterSeen', '1')
      navigate('/login')
    }, 5000)
    return () => clearTimeout(timer)
  }, [navigate])

  const handleClick = () => {
    localStorage.setItem('splashRegisterSeen', '1')
    navigate('/login')
  }

  return (
    <div 
      onClick={handleClick}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        cursor: 'pointer',
        backgroundColor: '#000'
      }}
    >
      <img 
        src={splashImg} 
        alt="Welcome to 1,2,3 High Community"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
      />
    </div>
  )
}
